<app-details-tab [loading]="loading" [toolbarItems]="toolbarItems" [model]="model" [errorMessage]="errorMessage">
  <br />

  <app-employee-document-grid [model]="model"></app-employee-document-grid>
</app-details-tab>
